// Style Imports
import Styles from './StepsDrawer.module.scss'

// Component Imports
import { Paper, Avatar, Drawer, Box, Typography, List, ListItem, ListItemButton, ListItemText, ListItemIcon } from '@mui/material';
import { CircularProgressWithLabel } from './CircularProgress';
import PlayArrow from '@mui/icons-material/PlayArrow';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import LockIcon from '@mui/icons-material/Lock';

const StepsDrawer = ({ open, onClose, steps, onStepClick, totalSteps, currentStep, nodeFinished, maxUnlocked }) => {
    const stepIcons = (flag, index) => {

        if (flag === 'current') {
            return <PlayArrow
                sx={{
                    color: currentStep === index ? "#ffffff" : "#3974c1",
                }}
            />
        }
        else if (flag === 'prev') {
            return <DoneAllIcon
                sx={{
                    color: currentStep === index ? "#ffffff" : "#3974c1",
                }}
            />
        }
        if (flag === 'next') {
            return <LockIcon
                sx={{
                    color: currentStep === index ? "#ffffff" : "lightgrey",
                }}
            />
        }
    };

    const getStepFlag = (index) => {
        if (index === maxUnlocked) return "current";    // current step
        if (index <= maxUnlocked) return "prev";        // completed and can navigate
        return "next";                                  // locked
    };

    return (
        <Drawer
            variant="temporary"
            open={open}
            onClose={onClose}
            ModalProps={{
                keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
                display: 'flex',
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '30vw' },
            }}
        >
            <Box onClick={onClose} sx={{ textAlign: 'center', height: '100%', backgroundColor: '#f2f2f2', overflow: 'hidden' }}>
                <div
                    id='progressionContainer'
                    className={Styles.progressionContainer}
                >
                    <Paper
                        elevation={4}
                        sx={{
                            width: "100%",
                            margin: "4px",
                            borderRadius: "34px",
                            height: "fit-content",
                            display: "flex",
                            alignItems: "center",
                            padding: "2px",
                            flexDirection: "row",
                            backgroundColor: "#EEEEEE",
                            overflowX: 'hide',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        <Avatar sx={{
                            bgcolor: "#393E46",
                            width: 62,
                            height: 62,
                            alignSelf: "flex-start"
                        }}>
                            <CircularProgressWithLabel
                                value={!nodeFinished
                                    ? Math.ceil(maxUnlocked / totalSteps * 100)
                                    : 100}
                                progresscolour={"#16FF00"}
                                textcolour={"white"} />
                        </Avatar>
                        <div
                            id='progressTextContainer'
                            className={Styles.progressTextContainer}
                        >
                            <Typography
                                // variant='h7'
                                sx={{
                                    // marginLeft: '10px',
                                    // marginRight: '10px',
                                    color: "#393E46",
                                }}>
                                Steps Completed: {maxUnlocked} / {totalSteps}
                            </Typography>
                        </div>
                    </Paper>
                </div>
                {/* <Divider /> */}
                <div
                    id='timeLineContainer'
                    className={Styles.timeLineContainer}
                >
                    <List>
                        {steps.map((step, index) => {
                            let flag = getStepFlag(index);
                            return (
                                <ListItem key={index} disablePadding>
                                    <ListItemButton
                                        disabled={flag === 'next'}
                                        onClick={() => onStepClick(index)}
                                        sx={{
                                            backgroundColor: currentStep === index ? '#3974c1' : 'transparent',
                                            color: currentStep === index ? '#ffffff' : '#000000',
                                            '&:hover': {
                                                backgroundColor: currentStep === index
                                                    ? '#3974c1'
                                                    : 'rgba(0, 0, 0, 0.08)',
                                            },
                                        }}
                                    >
                                        <ListItemIcon>
                                            {stepIcons(flag, index)}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={
                                                <Typography variant='body1' fontWeight={ index === maxUnlocked ? 'bold' : 'normal'}>
                                                    {step.timeline}
                                                </Typography>
                                            }
                                        />
                                    </ListItemButton>
                                </ListItem>
                            )
                        })}
                    </List>
                </div>
            </Box>
        </Drawer>
    );
};

export default StepsDrawer;
